import React from 'react'
import {
  Button,
  Box,
  CircularProgress,
  Snackbar,
  Paper,
} from '@mui/material'
import API from '@aws-amplify/api'
import MuiAlert from '@mui/material/Alert'
import { useDispatch } from 'react-redux'
import { DatePicker } from '@material-ui/pickers'
import { ISalesOrder } from 'interfaces/ISalesOrder'

const lastMonth = new Date()
lastMonth.setMonth(lastMonth.getMonth() - 1)

export default function ExportSalesOrder() {
  const [isLoading, setIsLoading] = React.useState<any>(false)
  const [isSuccessSnackbarOpen, setIsSuccessSnackbarOpen] =
    React.useState(false)
  const [isFailureSnackbarOpen, setIsFailureSnackbarOpen] =
    React.useState(false)
  const [alertMessage, setAlertMessage] = React.useState('')
  const [startDate, setStartDate] = React.useState<Date | null>(lastMonth)
  const [endDate, setEndDate] = React.useState<Date | null>(new Date())

  const handleSnackbarClose = (): void => {
    setIsFailureSnackbarOpen(false)
    setIsSuccessSnackbarOpen(false)
  }
  const onExportClick = () => {
    if (!startDate || !endDate) {
      return
    }

    startDate.setHours(0)
    endDate.setHours(23)
    startDate.setMinutes(0)
    endDate.setMinutes(59)
    startDate.setSeconds(0)
    endDate.setSeconds(59)
    startDate.setMilliseconds(0)
    endDate.setMilliseconds(999)

    let url = `/salesOrders/getSalesOrder`
    const param = {
      queryStringParameters: {
        startDate: startDate?.toISOString(),
        endDate: endDate?.toISOString(),
        pageSize: 9999999,
        isNotCancelled: true,
      },
    }

    setIsLoading(true)
    API.get('products', url, param)
      .then((response) => {
        const rows = [
          [
            'DF',
            'Sales Order ID',
            'TGL',
            'Nama Sales',
            'MEREK',
            'DKRM VIA',
            'KEMASAN',
            'ITEM',
            'QTY',
            'DUS',
            'HALAL',
            'SEGEL',
            'SHRINK',
            'BJ.',
            'NOTIF #',
          ],
        ]
        let counter = 1
        response.salesOrders.forEach((salesOrder: ISalesOrder) => {
          salesOrder.salesOrderProducts.forEach((salesOrderProduct) => {
            rows.push([
              String(counter++),
              salesOrder.salesOrderDisplayId || salesOrder.otDisplayId || '-',
              new Date(salesOrder.createdAt).toLocaleDateString('id-ID'),
              salesOrder.employeeName || '-',
              salesOrder.brandId || '-',
              salesOrder.shipmentType || '-',
              salesOrderProduct.packagingName || '-',
              salesOrderProduct.productName || '-',
              String(salesOrderProduct.productQty),
              salesOrderProduct.box ? 'DS' : '',
              salesOrderProduct.halal ? 'HL' : '',
              salesOrderProduct.seal ? 'SG' : '',
              salesOrderProduct.wrap ? 'SH' : '',
              `${[
                salesOrderProduct.premixId,
                salesOrderProduct.packagingId,
                salesOrderProduct.labelId,
              ]
                .filter((data) => data)
                .join('.')}`,
              salesOrderProduct.notificationNumber || '-',
            ])
          })
        })

        let csvContent = rows.map((e) => e.join('\t')).join('\n')
        const a = document.createElement('a')
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
        const url = window.URL.createObjectURL(blob)
        a.href = url
        a.download = 'salesOrder.csv'
        a.style.visibility = 'hidden'
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
      })
      .catch((error) => {
        setAlertMessage('Gagal export data.')
        setIsFailureSnackbarOpen(true)
        console.error(error.response)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const dispatch = useDispatch()
  React.useEffect(() => {
    dispatch({ type: 'SET_PAGE_TITLE', payload: 'Export Sales Order' })
  }, [dispatch])

  return (
    <Box>
      <Paper>
        <Box p={2} pt={0}>
          <DatePicker
            variant="inline"
            format="dd/MM/yyyy"
            margin="normal"
            fullWidth
            label="Start Date"
            value={startDate}
            onChange={(value) => setStartDate(value)}
            placeholder={`${new Date().getUTCDate()}/${new Date().getUTCMonth()}/${new Date().getUTCFullYear()}`}
          />
          <DatePicker
            variant="inline"
            format="dd/MM/yyyy"
            margin="normal"
            fullWidth
            label="End Date"
            value={endDate}
            onChange={(value) => setEndDate(value)}
            placeholder={`${new Date().getUTCDate()}/${
              new Date().getUTCMonth() + 1
            }/${new Date().getUTCFullYear()}`}
          />
          <Box mt={1}>
            <Button variant="contained" color="primary" onClick={onExportClick}>
              Export
            </Button>
          </Box>
        </Box>
      </Paper>
      <Snackbar
        open={isSuccessSnackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert severity="success" elevation={6} variant="filled">
          {alertMessage}
        </MuiAlert>
      </Snackbar>
      <Snackbar
        open={isFailureSnackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert severity="error" elevation={6} variant="filled">
          {alertMessage}
        </MuiAlert>
      </Snackbar>
      {isLoading && (
        <Box p={3}>
          <CircularProgress />
        </Box>
      )}
    </Box>
  )
}
